import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { GridComponent } from '@syncfusion/ej2-angular-grids';
import { ToastrService } from 'ngx-toastr';
import printJS from 'print-js';
import { Subject, Subscription, take } from 'rxjs';
import { GeneralService } from 'src/app/services/general.service';
import { PosSettingsService } from 'src/app/services/pos-settings.service';
import { OperationRentalService } from 'src/app/services/Rentals.service';
import { VendorService } from 'src/app/services/Vendor.service';
import { RentalReceiptIDs } from 'src/app/Shared/enum';
import { LoaderComponent } from 'src/app/Shared/loader/loader.component';
import { ASLicenseSettings } from 'src/app/Shared/model/GeneralModel';
import { PhoneFormatPipe } from 'src/app/Shared/phone-format.pipe';
import { RentalPayByboothComponent } from 'src/app/Shared/rental-pay-bybooth/rental-pay-bybooth.component';
import { ANGULAR_MODULES, SYNCFUSION_MODULES } from 'src/app/Shared/shared-imports';
import { SharedHTMLSettingsDataService } from 'src/app/Shared/sharedHTMLSettingsData.service';
import { ZipCodePipe } from 'src/app/Shared/zip-code.pipe';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-ops-vendor-dashboard',
  imports: [ANGULAR_MODULES, SYNCFUSION_MODULES, RentalPayByboothComponent, LoaderComponent, ZipCodePipe, PhoneFormatPipe],
  standalone: true,
  templateUrl: './ops-vendor-dashboard.html',
  styleUrl: './ops-vendor-dashboard.scss',
})

export class OpsVendorDashboard implements OnInit {
  constructor(private vendorService: VendorService,
    private toastr: ToastrService,
    private rentalService: OperationRentalService,
    private sharedHTMLSettings: SharedHTMLSettingsDataService,
    private posSettingsService: PosSettingsService,
    private sanitizer: DomSanitizer,
    private generalService: GeneralService
  ) { }

  receiptUrl: SafeResourceUrl | null = null;
  loading = false;
  Dues = [];
  @ViewChild('gridRentalStatus', { static: false }) public gridRentalStatus: GridComponent;
  @Output() isFormDirty = new EventEmitter<any>();
  payByBooth = false;
  rentalData = [];
  @Input() vendorId;
  vendorDashboardInfo;
  logoPreviewUrl: string = './assets/images/NoPhoto.svg';
  isWebInquiryEnabled = true;
  loaderIcon: Promise<boolean>;
  timestamp = new Date().getTime();
  private subscriptions: Subscription[] = [];

  VendorComment = ""
  IsVendorInActive = false;
  IsWebInquiryEnabled = false;

  AutoDeductRent = false;
  EnableConsignmentCom = false;
  ApplyFlatComPos = false;
  FlatComPos = '';
  ConsignmentCom = '';

  uniqueSessionId = "";
  priorBalance = 0;

  response;
  hasActiveBoothRental: boolean = false;
  private destroy$ = new Subject<void>();

  originalFlatCommission = 0;
  hasTransactionsAfterLastPayout = false;
  enableInventoryControl = false;
  hasInventoryTransactions = false;
  defaultFlatCommission = 0;
  defaultConCommission = 0;

  ngOnInit(): void {
    const tabId = sessionStorage.getItem('tabId');
    const sessionKey = `UniqueSessionId-${tabId}`;
    this.uniqueSessionId = localStorage.getItem(sessionKey);
    this.getVendorBalances();
    this.getVendorDashboardDetails();
    this.getVendorMarketRentalStatus();
    this.getVendorNotes()
    this.getVendorCommissionUpdateStatus();
    this.getASCloudLicenseSettings();
    this.loadDefaultPOSCommission();

  }

  getVendorBalances() {
    this.subscriptions.push(this.vendorService.getVendorBalances(this.vendorId).subscribe(res => {
      if (res) {
        this.priorBalance = res.PriorBalance == null ? 0 : res.PriorBalance;
      }
    }));
  }

  getVendorDashboardDetails() {
    this.loaderIcon = Promise.resolve(true);
    this.subscriptions.push(this.vendorService.GetVendorDashboardById(this.vendorId).subscribe((res: any) => {
      if (!res) {
        this.toastr.error($localize`Something went wrong`, $localize`Failed`, this.sharedHTMLSettings.ToasterConfig);
        this.loaderIcon = Promise.resolve(false);
        return;
      }
      const result = res;
      this.vendorDashboardInfo = {
        VendorId: result.VendorId,
        MarketVendorId: result.MarketVendorId,
        VendorName: result.VendorName,
        State: result.State,
        Email: result.Email,
        City: result.City,
        WorkPhone: result.WorkPhone,
        TelePhone: result.TelePhone,
        WorkPhoneEXT: result.WorkPhoneEXT ?? "",
        VendorSince: result.VendorSince,
        IsInActive: result.IsInActive,
        AutoPayRent: result.AutoPayRent,
        Comment: result.Comment ?? "",
        VendorProfile: result.VendorProfile ?? "",
        OpenEdgeAlias: result.OpenEdgeAlias ?? "",
        CellPhone: result.CellPhone ?? "",
        EnableWebInquiry: result.EnableWebInquiry,
        EnableConsignmentCom: result.EnableConsignmentCom,
        ApplyFlatComPos: result.ApplyFlatComPos,
        FlatComPos: result.FlatComPos,
        ConsignmentCom: result.ConsignmentCom
      };
      this.VendorComment = result.Comment ?? "";
      this.IsVendorInActive = result.IsInActive;
      this.IsWebInquiryEnabled = result.EnableWebInquiry;
      this.ApplyFlatComPos = result.ApplyFlatComPos;
      this.EnableConsignmentCom = result.EnableConsignmentCom;
      this.AutoDeductRent = result.AutoPayRent;

      this.FlatComPos = `${Number(result.FlatComPos ?? 0).toFixed(2)}%`;
      this.ConsignmentCom = `${Number(result.ConsignmentCom ?? 0).toFixed(2)}%`;
      this.originalFlatCommission = Number(result.FlatComPos);

      this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    }));
  }

  getVendorMarketRentalStatus() {
    this.loaderIcon = Promise.resolve(true);
    this.subscriptions.push(this.vendorService.getVendorMarketRentalStatus(this.vendorId).subscribe((res: any) => {
      if (!res) {
        this.toastr.error($localize`Something went wrong`, $localize`Failed`, this.sharedHTMLSettings.ToasterConfig);
        this.loaderIcon = Promise.resolve(false);
        return;
      }

      const rentalBooths = res.RentedBooths ? res.RentedBooths.split(',').map(b => b.trim()).filter(b => b.length > 0) : [];
      this.hasActiveBoothRental = rentalBooths.length > 0;
      this.rentalData.push(res);
      this.gridRentalStatus.refresh();
      this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    }));
  }

  notesData = [
    { createdDate: '', notes: '' }
  ];

  openPaymentPage() {
    if (!this.IsVendorInActive) {
      Swal.fire({
        icon: 'warning',
        title: 'Inactive Vendor',
        text: 'This vendor is inactive. This action cannot be performed.',
        confirmButtonText: 'OK'
      });
      return;
    }

    this.subscriptions.push(this.rentalService.getVendorRentalDues(this.vendorId).subscribe((res) => {
      this.Dues = res;
      this.payByBooth = true;
      this.isFormDirty.emit(true);
    }))
  }

  cancelPayByBooth(val) {
    this.payByBooth = !val;
    this.isFormDirty.emit(!val);
    this.rentalData = [];
    this.getVendorMarketRentalStatus();
  }

  closePayByBooth(val) {
    this.getVendorBalances();
    this.payByBooth = !val;
    this.isFormDirty.emit(!val);
    this.rentalData = [];
    this.getVendorMarketRentalStatus();
  }

  onLogoSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const file = input.files[0];
      const reader = new FileReader();

      reader.onload = () => {
        this.logoPreviewUrl = reader.result as string;
      };

      reader.readAsDataURL(file);
    }
  }

  toggleInquiry(event: Event): void {
    this.isWebInquiryEnabled = (event.target as HTMLInputElement).checked;
    console.log('Web Inquiry:', this.isWebInquiryEnabled);
  }

  updateVendorComment() {
    this.loaderIcon = Promise.resolve(true);
    const commentdata = {
      VendorId: this.vendorId,
      Comment: this.VendorComment
    }
    this.subscriptions.push(this.vendorService.UpdateOrSaveVendorComment(commentdata).subscribe((res: any[]) => {
      this.response = res;
      if (this.response.Success) {
        this.toastr.success(this.response.Message, $localize`Success`, this.sharedHTMLSettings.ToasterConfig);
        this.vendorDashboardInfo.Comment = this.VendorComment;
      }
      else {
        this.toastr.error(this.response.Message, $localize`Error`, this.sharedHTMLSettings.ToasterConfig)
      }
      this.loaderIcon = Promise.resolve(false);

    }, (err) => {
      this.toastr.error($localize`Something Went Wrong`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig)
      this.loaderIcon = Promise.resolve(false);
    }));
  }

  getVendorNotes() {
    this.loaderIcon = Promise.resolve(true);
    this.subscriptions.push(this.vendorService.getVendorNotesById(this.vendorId).subscribe((res: any) => {
      if (res.length != 0) {

        const result = res;
        this.notesData = result.map((el, i) => ({
          VendorId: el.VendorId,
          NoteId: el.VendorNotesId,
          Notes: el.VendorNotes,
          CreatedOn: el.VnoDtmEntryDateString,
        }));
      }
      this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    }));

  }

  ToggleActiveStatus() {

    Swal.fire({
      title: $localize`Are you sure ?`,
      text: $localize`Confirm Change to Active Status ?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: $localize`Yes`,
      cancelButtonText: $localize`No`,

    }).then((result) => {
      if (result.value) {
        this.UpdateVendorStatus();
      } else {
        this.IsVendorInActive = this.vendorDashboardInfo.IsInActive;
      }
    });
  }

  ToggleWebInquiryStatus() {

    if (this.vendorDashboardInfo.Email == null || this.vendorDashboardInfo.Email.trim() == "") {
      this.toastr.error($localize`Vendor Email is required to update Web Inquiry`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig)
      this.IsWebInquiryEnabled = this.vendorDashboardInfo.EnableWebInquiry;
      return;
    }

    Swal.fire({
      title: $localize`Are you sure ?`,
      text: $localize`you want to change the web inquiry status?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: $localize`Yes`,
      cancelButtonText: $localize`No`,

    }).then((result) => {
      if (result.value) {
        this.UpdateVendorStatus();
      } else {
        this.IsWebInquiryEnabled = this.vendorDashboardInfo.EnableWebInquiry;
      }
    });
  }

  UpdateVendorStatus() {
    this.loaderIcon = Promise.resolve(true);

    const vendorstatus = {
      VendorId: this.vendorId,
      IsInActive: this.IsVendorInActive,
      EnableWebInquiry: this.IsWebInquiryEnabled,
      AutoDeductRent: this.AutoDeductRent
    }

    this.subscriptions.push(this.vendorService.UpdateVendorStatus(vendorstatus).subscribe((res: any[]) => {
      this.response = res;
      if (this.response.Success) {
        this.toastr.success(this.response.Message, $localize`Success`, this.sharedHTMLSettings.ToasterConfig);
        this.vendorDashboardInfo.EnableWebEnquiry = this.IsWebInquiryEnabled;
        this.vendorDashboardInfo.IsInActive = this.IsVendorInActive;
        this.vendorDashboardInfo.AutoPayRent = this.AutoDeductRent;
      }
      else {
        this.toastr.error(this.response.Message, $localize`Error`, this.sharedHTMLSettings.ToasterConfig)
      }
      this.loaderIcon = Promise.resolve(false);

    }, (err) => {
      this.toastr.error($localize`Something Went Wrong`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig)
      this.loaderIcon = Promise.resolve(false);
    }));
  }

  allowOnlyNumbers(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    const key = event.key;

    // Allow navigation keys
    if (
      key === 'Backspace' ||
      key === 'Delete' ||
      key === 'ArrowLeft' ||
      key === 'ArrowRight' ||
      key === 'Tab'
    ) {
      return;
    }

    // Allow numbers and single dot
    if (!/[0-9.]/.test(key)) {
      event.preventDefault();
      return;
    }

    if (key === '.' && value.includes('.')) {
      event.preventDefault();
      return;
    }

    const decimalIndex = value.indexOf('.');
    if (decimalIndex >= 0 && value.split('.')[1].length >= 2 && input.selectionStart! > decimalIndex) {
      event.preventDefault();
    }
  }


  fillZeroIfEmpty() {
    if (this.ConsignmentCom == '') {
      this.ConsignmentCom = '0';
    }
    if (this.FlatComPos == '') {
      this.FlatComPos = '0';
    }
  }

  ToggleAutoDeRent() {

    Swal.fire({
      title: $localize`Are you sure ?`,
      text: this.AutoDeductRent == false ? $localize`Allow Auto Deduct Rent` : $localize`Cancel Auto Deduct Rent`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: $localize`Yes`,
      cancelButtonText: $localize`No`,

    }).then((result) => {
      if (result.value) {
        this.UpdateVendorStatus();
      } else {
        this.AutoDeductRent = this.vendorDashboardInfo.AutoPayRent;
      }
    });
  }


  private showFlatCommissionPopup(comm: any): void {

    Swal.fire({
      title: 'Vendor',
      text: 'Do you want to change the Flat Commission for the current payout period?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then(result => {

      const updateModel = {
        VendorId: this.vendorId,
        FlatCommission: parseFloat(comm.Commission.toString().replace('%', '')) || 0,
        UpdatePosInvoiceItems: result.isConfirmed,
        UpdateInventoryItems: false
      };

      if (this.enableInventoryControl && this.hasInventoryTransactions) {
        this.showInventoryPopup(comm, updateModel);
      } else {
        this.UpdateConsignmentOrFlatPosComm(comm, updateModel);
      }
    });
  }

  private updateFlatCommission(updateModel: any): void {

    this.vendorService.UpdateVendorFlatCommission(updateModel)
      .subscribe({
        next: (res: any) => {

          if (res.Success) {
            this.toastr.success(
              $localize`Flat commission updated successfully.`,
              $localize`Success`,
              this.sharedHTMLSettings.ToasterConfig
            );
          } else {
            this.toastr.error(
              res.Message,
              $localize`Error`,
              this.sharedHTMLSettings.ToasterConfig
            );
          }

        },
        error: () => {
          this.toastr.error(
            $localize`Something Went Wrong`,
            $localize`Error`,
            this.sharedHTMLSettings.ToasterConfig
          );
        }
      });
  }

  private showInventoryPopup(comm: any, updateModel: any): void {

    Swal.fire({
      title: 'Vendor',
      text: 'Do you want to change the Flat Commission for the Existing Inventory Items of this Vendor?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then(result => {

      updateModel.UpdateInventoryItems = result.isConfirmed;

      this.UpdateConsignmentOrFlatPosComm(comm, updateModel);
    });
  }

  async ToggleConsComm() {

    if (this.EnableConsignmentCom == false) {

      const { value: formValue, dismiss } = await Swal.fire({
        title: "Enter Consignment Commission",
        html: `
            <input id="swal-input2" class="swal2-input">
          `,
        focusConfirm: false,
        showCancelButton: true,
        didOpen: () => {
          const inputEl = document.getElementById("swal-input2") as HTMLInputElement;
          inputEl.value = (parseFloat(this.ConsignmentCom) || 0).toFixed(2);
          inputEl.addEventListener("keypress", (event) => {
            this.allowOnlyNumbers(event);
          });

          inputEl.addEventListener("input", () => {
            let value = parseFloat(inputEl.value);

            if (!isNaN(value) && value > 100) {
              inputEl.value = "100";
            }
          });

          inputEl.addEventListener("blur", () => {
            this.fillZeroIfEmpty();
          });
        },
        preConfirm: () => {

          const input = document.getElementById("swal-input2") as HTMLInputElement;
          let value = parseFloat(input.value);
          if (isNaN(value)) {
            value = 0;
          }
          if (value > 100) {
            value = 100;
            input.value = "100";
          }
          return value.toFixed(2);
        }
      });
      if (dismiss === Swal.DismissReason.cancel) {
        this.EnableConsignmentCom = false;
        return;
      }
      if (formValue) {
        const data = {
          Enable: true,
          Commission: formValue,
          VendorId: this.vendorId,
          IsFlatPosComm: false
        }
        this.UpdateConsignmentOrFlatPosComm(data);
      }

    } else {

      Swal.fire({
        title: $localize`Are you sure ?`,
        text: $localize`Disable Consignment Commission`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: $localize`Yes`,
        cancelButtonText: $localize`No`,
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then((result) => {
        if (result.value) {
          const data = {
            Enable: false,
            Commission: this.defaultConCommission,
            VendorId: this.vendorId,
            IsFlatPosComm: false
          }
          this.UpdateConsignmentOrFlatPosComm(data);
        } else {
          this.ConsignmentCom = `${Number(this.vendorDashboardInfo.ConsignmentCom ?? 0).toFixed(2)}%`;
          this.EnableConsignmentCom = true;
        }
      });
    }
  }

  async TogglFlatCommPos() {
    if (this.ApplyFlatComPos == false) {

      const { value: formValue, dismiss } = await Swal.fire({
        title: "Enter Flat Commission on POS(%)",
        html: `
            <input id="swal-input1" class="swal2-input" >
          `,
        focusConfirm: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        showCancelButton: true,
        didOpen: () => {
          const inputEl = document.getElementById("swal-input1") as HTMLInputElement;
          inputEl.value = (parseFloat(this.FlatComPos) || 0).toFixed(2);
          inputEl.addEventListener("keypress", (event) => {
            this.allowOnlyNumbers(event);
          });

          inputEl.addEventListener("input", () => {
            let value = parseFloat(inputEl.value);

            if (!isNaN(value) && value > 100) {
              inputEl.value = "100";
            }
          });

          inputEl.addEventListener("blur", () => {
            this.fillZeroIfEmpty();
          });
        },
        preConfirm: () => {
          const input = document.getElementById("swal-input1") as HTMLInputElement;
          let value = parseFloat(input.value);
          if (isNaN(value)) {
            value = 0;
          }
          if (value > 100) {
            value = 100;
            input.value = "100";
          }
          return value.toFixed(2);
        },
      });
      if (dismiss === Swal.DismissReason.cancel) {
        this.ApplyFlatComPos = false;
        return;
      }
      if (formValue) {
        const data = {
          Enable: true,
          Commission: formValue,
          VendorId: this.vendorId,
          IsFlatPosComm: true
        }
        this.UpdateConsignmentOrFlatPosComm(data);
      }
    } else {

      Swal.fire({
        title: $localize`Are you sure ?`,
        text: $localize`Disable Flat Commission on POS`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: $localize`Yes`,
        cancelButtonText: $localize`No`,
        allowOutsideClick: false,
        allowEscapeKey: false,

      }).then((result) => {
        if (result.value) {
          const data = {
            Enable: false,
            Commission: this.defaultFlatCommission,
            VendorId: this.vendorId,
            IsFlatPosComm: true
          }
          this.UpdateConsignmentOrFlatPosComm(data);
        } else {
          this.FlatComPos = `${Number(this.vendorDashboardInfo.FlatComPos ?? 0).toFixed(2)}%`;
          this.ApplyFlatComPos = true
        }
      });
    }
  }

  UpdateConsignmentOrFlatPosComm(comm, updateModel = null) {
    this.loaderIcon = Promise.resolve(true);
    const commission = parseFloat(comm.Commission.toString().replace('%', '')) || 0;

    // Only Flat Commission needs the extra prompts
    if (comm.IsFlatPosComm &&
      updateModel == null &&
      commission !== this.originalFlatCommission) {

      if (this.hasTransactionsAfterLastPayout) {
        this.loaderIcon = Promise.resolve(false);
        return this.showFlatCommissionPopup(comm);
      }

      if (this.enableInventoryControl && this.hasInventoryTransactions) {
        this.loaderIcon = Promise.resolve(false);
        return this.showInventoryPopup(comm, {
          VendorId: this.vendorId,
          FlatCommission: commission,
          UpdatePosInvoiceItems: false,
          UpdateInventoryItems: false
        });
      }
    }

    const data = {
      Enable: comm.Enable,
      Commission: commission.toFixed(2),
      VendorId: comm.VendorId,
      IsFlatPosComm: comm.IsFlatPosComm
    }

    this.subscriptions.push(this.vendorService.UpdateConsignmentOrFlatPosComm(data).subscribe((res: any[]) => {
      this.response = res;
      if (this.response.Success) {
        if (comm.IsFlatPosComm) {
          this.FlatComPos = `${commission.toFixed(2)}%`;
          this.vendorDashboardInfo.FlatComPos = commission;
          this.originalFlatCommission = commission;
        } else {
          this.ConsignmentCom = `${commission.toFixed(2)}%`;
          this.vendorDashboardInfo.ConsignmentCom = commission;
        }

        if (updateModel &&
          (updateModel.UpdatePosInvoiceItems || updateModel.UpdateInventoryItems)) {

          this.updateFlatCommission(updateModel);
        }
        this.toastr.success(this.response.Message, $localize`Success`, this.sharedHTMLSettings.ToasterConfig);
        this.loaderIcon = Promise.resolve(false);
      }
    }));
  }

  async updateFlatCommPos() {
    if (this.ApplyFlatComPos == true) {
      const { value: formValue, dismiss } = await Swal.fire({
        title: "Enter Flat Commission on POS(%)",
        html: `
          <input id="swal-input3" class="swal2-input" >
        `,
        focusConfirm: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        showCancelButton: true,
        didOpen: () => {
          const inputEl = document.getElementById("swal-input3") as HTMLInputElement;
          inputEl.value = (parseFloat(this.FlatComPos) || 0).toFixed(2);
          inputEl.addEventListener("keypress", (event) => {
            this.allowOnlyNumbers(event);
          });

          inputEl.addEventListener("input", () => {
            let value = parseFloat(inputEl.value);

            if (!isNaN(value) && value > 100) {
              inputEl.value = "100";
            }
          });

          inputEl.addEventListener("blur", () => {
            this.fillZeroIfEmpty();
          });
        },
        preConfirm: () => {

          const input = document.getElementById("swal-input3") as HTMLInputElement;
          let value = parseFloat(input.value);
          if (isNaN(value)) {
            value = 0;
          }
          if (value > 100) {
            value = 100;
            input.value = "100";
          }
          return value.toFixed(2);
        },
      });
      if (dismiss === Swal.DismissReason.cancel) {
        return;
      }
      if (formValue) {
        const data = {
          Enable: true,
          Commission: formValue,
          VendorId: this.vendorId,
          IsFlatPosComm: true
        }
        this.UpdateConsignmentOrFlatPosComm(data);
      }
    }
  }

  async updateConsignmentCom() {
    if (this.EnableConsignmentCom == true) {
      const { value: formValue, dismiss } = await Swal.fire({
        title: "Enter Consignment Commission",
        html: `
          <input id="swal-input4" class="swal2-input">
        `,
        focusConfirm: false,
        showCancelButton: true,
        didOpen: () => {
          const inputEl = document.getElementById("swal-input4") as HTMLInputElement;
          inputEl.value = (parseFloat(this.ConsignmentCom) || 0).toFixed(2);
          inputEl.addEventListener("keypress", (event) => {
            this.allowOnlyNumbers(event);
          });

          inputEl.addEventListener("input", () => {
            let value = parseFloat(inputEl.value);

            if (!isNaN(value) && value > 100) {
              inputEl.value = "100";
            }
          });

          inputEl.addEventListener("blur", () => {
            this.fillZeroIfEmpty();
          });
        },
        preConfirm: () => {
          const input = document.getElementById("swal-input4") as HTMLInputElement;
          let value = parseFloat(input.value);
          if (isNaN(value)) {
            value = 0;
          }
          if (value > 100) {
            value = 100;
            input.value = "100";
          }
          return value.toFixed(2);
        }
      });
      if (dismiss === Swal.DismissReason.cancel) {
        return;
      }
      if (formValue) {
        const data = {
          Enable: true,
          Commission: formValue,
          VendorId: this.vendorId,
          IsFlatPosComm: false
        }
        this.UpdateConsignmentOrFlatPosComm(data);
      }
    }
  }

  HandleReceipts(data) {
    if (data.showReceipt || data.print || data.email) {
      this.printReceipts(data);
    }
  }

  printReceipts(data) {
    this.loaderIcon = Promise.resolve(true);
    // Helper to generate and process a PDF
    var rentalType = data.rentalType;
    const generateAndProcessPDF = (
      type: 'Receipt',
      documentId: number,
      display: boolean,
      print: boolean,
      email: boolean,
      baseTemplateId: number,
      emailSubject: string
    ) => {
      const params = {
        VendorId: parseInt(this.vendorId),
        AccountReceiptId: data.receiptId,
        RentalType: rentalType,
        PaymentOnly: true,
        DocumentId: documentId
      };

      this.subscriptions.push(
        this.rentalService.generatePaymentReceipt(params).subscribe((res: any) => {
          this.loaderIcon = Promise.resolve(false);
          if (!res.Success) return;
          const message = res.Message;
          if (!message || !message.startsWith('data:application/pdf;base64,')) {
            Swal.fire('Error', `Invalid ${type} PDF data in response`, 'error');
            return;
          }

          if (print && type == 'Receipt' && data.printThermal) {
            let params = 'methodname=RentalPaymentReceipt&param1=' + data.receiptId + '&param2=' + rentalType + '&param3=' + parseInt(this.vendorId) + '&param4=True&param5=' + data.thermalReceiptCopies + '&uniqueSessionId=' + this.uniqueSessionId;;
            if (data != null) {
              if (data?.rentalMerchantCopy || data?.rentalCustomerCopy) {
                params += `&MerchantCopy=${data.rentalMerchantCopy}&CustomerCopy=${data.rentalCustomerCopy}&MerchantNoOfCopies=${data.rentalMerchantNoOfCopies}&CustomerNoOfCopies=${data.rentalCustomerNoOfCopies}`;
              }
            }

            const customProtocolUrl = `silentprinter://?${params}`;
            window.location.href = customProtocolUrl;
          }

          // --- DISPLAY PDF IN MODAL ---
          if (display) {
            this.showPDFModal(message);
          }

          // --- EMAIL PDF ---
          if (email) {
            this.sendEmail(
              data.receiptId,
              baseTemplateId,
              message,
              `Rental ${type}`,
              emailSubject
            );
          }

          if (print && !data.printThermal) {
            printJS({
              printable: message.split(',')[1],
              type: 'pdf',
              base64: true,
            });
          }
        })
      );
    };

    // Handle Receipt
    if (data.showReceipt || data.print || data.email) {
      generateAndProcessPDF(
        'Receipt',
        RentalReceiptIDs.MonthlyReceipt,
        data.showReceipt,
        data.print,
        data.email,
        2,
        'Monthly Rental Receipt'
      );
    }
  }

  private showPDFModal(base64Data: string) {
    this.loading = true;
    const modalId = 'printReceiptPopup';
    const pdfVar = 'receiptUrl';

    const modalEl = document.getElementById(modalId);
    if (modalEl) {
      let modalInstance = window['bootstrap'].Modal.getInstance(modalEl);
      if (!modalInstance) {
        modalInstance = new window['bootstrap'].Modal(modalEl);
      }
      modalInstance.show();
    }

    const pdfBase64 = base64Data.split(',')[1];
    const blob = this.base64ToBlob(pdfBase64, 'application/pdf');
    this[pdfVar] = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob));
    this.loading = false;
  }

  private sendEmail(
    accountReceiptId: number,
    baseTemplateId: number,
    message: string,
    fileName: string,
    subject: string
  ) {
    const emailData = [{
      AccountReceiptID: accountReceiptId,
      VendorID: parseInt(this.vendorId),
      BaseTemplateID: baseTemplateId,
      AttachmentFile: message,
      AttachmentFileName: fileName,
      FileType: "application/pdf",
      Subject: subject
    }];

    this.generalService.composeEmails(emailData).subscribe(() => {
      console.log(`${subject} email sent successfully`);
    });
  }

  private base64ToBlob(base64: string, type: string): Blob {
    const byteCharacters = atob(base64);
    const byteArray = new Uint8Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteArray[i] = byteCharacters.charCodeAt(i);
    }
    return new Blob([byteArray], { type });
  }

  onWebInquiryToggleClick(event: Event) {
    const hasEmail = !!this.vendorDashboardInfo?.Email?.trim();
    if (!hasEmail) {
      event.preventDefault();
      event.stopPropagation();
      this.toastr.error(
        $localize`Vendor Email is required to update Web Inquiry`,
        $localize`Error`,
        this.sharedHTMLSettings.ToasterConfig
      );
      return;
    }

    this.ToggleWebInquiryStatus();
  }

  onToggleActiveStatusClick(event: Event) {
    if (this.IsVendorInActive && this.hasActiveBoothRental) {
      event.preventDefault();
      event.stopPropagation();
      Swal.fire({
        title: $localize`Action Not Allowed`,
        text: $localize`Vendor has an active booth rental. Status cannot be changed until the booth rental is closed.`,
        icon: 'info',
        confirmButtonText: $localize`OK`
      });
      this.IsVendorInActive = this.vendorDashboardInfo.IsInActive;
      return;
    }

    this.ToggleActiveStatus();
  }


  getVendorCommissionUpdateStatus(): void {
    this.vendorService
      .HasVendorTransactionsAfterLastPayout(this.vendorId)
      .subscribe({
        next: (res: any) => {
          this.hasTransactionsAfterLastPayout = res?.HasTransactionsAfterLastPayout ?? false;
          this.hasInventoryTransactions = res?.HasInventoryTransactions ?? false;
        },
        error: () => {
          this.hasTransactionsAfterLastPayout = false;
          this.hasInventoryTransactions = false;
        }
      });
  }

  getASCloudLicenseSettings(): void {
    const licenseSettings = this.generalService.ASLicenseSettings;
    if (licenseSettings !== null) {
      this.enableInventoryControl = licenseSettings.EnableInventoryControl ?? false;
      return;
    }

    this.generalService.getASCloudLicenseSettings().pipe(take(1)).subscribe({
      next: (res: ASLicenseSettings) => {
        this.generalService.ASLicenseSettings = res;
        this.enableInventoryControl = res.EnableInventoryControl ?? false;
      },
      error: () => {
        this.enableInventoryControl = false;
      }
    });
  }

  private loadDefaultPOSCommission(): void {

    this.subscriptions.push(
      this.posSettingsService.getSalesTaxAndCommission()
        .subscribe((res: any) => {
          this.defaultFlatCommission = Number(res?.Commission?.FlatCommission) || 0;
          this.defaultConCommission = Number(res?.Commission?.DealerConCommPercent) || 0;
        })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
  }
}
